export default "__VITE_ASSET__vsxmHNLX__"